<script setup>
import TvSection from '~/components/tv/TvSection.vue';
import TvJoinCode from '~/components/tv/TvJoinCode.vue';

// The club's own join code, at the foot of the sidebar
defineProps({
  code: {type: Object, required: true},
  clubName: {type: String, required: true},
});
</script>

<template>
  <tv-section>
    <tv-join-code :code="code" :title="`Scan to join ${clubName}`" :size="150"/>
  </tv-section>
</template>
